
import { ServiceTestimonials } from "@/components/ServiceTestimonials";
import { wisdomToothData } from "./wisdomToothData";

export const WisdomToothTestimonials = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <ServiceTestimonials 
          testimonials={wisdomToothData.testimonials}
          title="Patient Testimonials"
          subtitle="What Our Patients Say About Wisdom Tooth Removal"
        />
      </div>
    </section>
  );
};
